// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","455":"d68be2e7","977":"9cfa6e4f"}[chunkId] + ".chunk.js";
};